module.exports = __webpack_public_path__ + "images/up-icon.69428790b551f333a317bb13230afd2b.png";